import React from 'react';
import { AdapterGenerico } from '../../../../shared/Infraestructure/AdapterGenerico';
import { LanguageTranslate } from '../../../../shared/Infraestructure/LanguageTranslate';
import { EntityMain } from '../../Domain/EntityMain';
import { EntityModeMultipleSelect } from '../../Domain/EntityModeMultipleSelect';
import { EntityRendicionGasto } from '../../../../shared/Domain/EntityRendicionGasto';

interface ContainerProps {
    data: EntityMain<EntityRendicionGasto>[];
    onRedirectForm(id: string): any;
    show: boolean;
    copyCodeItem: (code: string) => Promise<void>;
    modeMultipleSelect: EntityModeMultipleSelect;
    onSelectItem: (code: string) => void;
}

export const ViewRendicionGasto = (props: ContainerProps) => {
    if (!props.show) return null;

    const languageTranslate = LanguageTranslate();
    return (
        <div className="row pt-3 mb-5">
            <div className="col-12 mb-5">
                {
                    props.data.map(row => {
                        if (props.modeMultipleSelect.active && row.isPendingSend) return null;
                        if (props.modeMultipleSelect.active && row.dataComplete.Status.Rendicion.IdStatus !== 0) return null;
                        const classNameItem: any = {
                            0: 'ItemOpen',
                            1: 'ItemRevisado',
                            5: 'ItemRevision',
                            10: 'ItemRechazado'
                        }
                        const itemStatus: any = {
                            0: languageTranslate.textoEstadoAbierto,
                            1: languageTranslate.textoEstadoAprobado,
                            5: languageTranslate.textoEstadoEnAprobacion,
                            10: languageTranslate.textoEstadoDevuelto,
                        }

                        return (
                            <div className="row pb-3 ItemGenericList" key={row.Codigo}>
                                <div className="col-12">
                                    <div className={`shadow-lg position-relative ${classNameItem[row.dataComplete.Status.Rendicion.IdStatus]} ${row.isPendingSend ? 'pending' : ''}`} style={{ width: '100%', padding: 5, margin: 0, borderRadius: '10px', cursor: 'pointer' }}>
                                        <div className={`${props.modeMultipleSelect.active ? 'ModeSelectItem' : ''} ${props.modeMultipleSelect.listCode.includes(row.Codigo) ? 'ModeSelectItem-select' : ''}`} onClick={() => props.onSelectItem(row.Codigo)} />

                                        <div className="row pt-1" style={{ margin: '1px' }}>
                                            <div className="col-10" onClick={(evt) => props.copyCodeItem(row.Codigo)}>
                                                <span className='fw-semibold' style={{ fontSize: '14px' }}> {row.Codigo}</span>
                                                <button className='icon-copy-custom'><i className="fa-solid fa-copy" /></button>
                                            </div>
                                        </div>

                                        <div className="row pt-1" style={{ margin: '1px' }} onClick={() => props.onRedirectForm(row.Codigo)} >
                                            <div className="col-10" style={{ fontSize: 12 }}>
                                                <div className='d-flex'>
                                                    <span>{languageTranslate.moduloGenericList.item.itemTextOT}:</span>
                                                    <span className='text-muted'> {row.dataComplete.DatosTrabajo.OT.OT} </span>
                                                </div>
                                                <div className='d-flex'>
                                                    <span>{languageTranslate.moduloGenericList.item.itemTextImporte}:</span>
                                                    <span className='text-muted'> {row.dataComplete.DatosImporte.Importe} {row.dataComplete.DatosImporte.Moneda.Moneda}</span>
                                                </div>
                                                <div className='d-flex'>
                                                    <span>{languageTranslate.moduloGenericList.item.itemTextCantidadLinea}:</span>
                                                    <span className='text-muted'> {row.dataComplete.GastoAsociado.length}</span>
                                                </div>
                                            </div>
                                            <div className="icon-arrow-item">
                                                <i className="fa-solid fa-angle-right" style={{ fontSize: '20px' }} />
                                            </div>
                                        </div>
                                        <div className="row pt-1" style={{ margin: '1px' }} onClick={() => props.onRedirectForm(row.Codigo)} >
                                            <div className="col-6">
                                                <span className='text-danger' style={{ fontSize: '13px' }}> {AdapterGenerico.calculoTiempo(row.FechaRegistro)} </span>
                                            </div>
                                            <div className="col-6 GroupBadge">
                                                <div className="badgeCustom">
                                                    {
                                                        <span>{itemStatus[row.dataComplete.Status.Rendicion.IdStatus]}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}